<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__stroke"
      d="M6 8H15"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      class="icon__fill"
      d="M11.7071 3.29289C11.3166 2.90237 10.6834 2.90237 10.2929 3.29289C9.90237 3.68342 9.90237 4.31658 10.2929 4.70711L11.7071 3.29289ZM15 8L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L15 8ZM10.2929 11.2929C9.90237 11.6834 9.90237 12.3166 10.2929 12.7071C10.6834 13.0976 11.3166 13.0976 11.7071 12.7071L10.2929 11.2929ZM10.2929 4.70711L14.2929 8.70711L15.7071 7.29289L11.7071 3.29289L10.2929 4.70711ZM14.2929 7.29289L10.2929 11.2929L11.7071 12.7071L15.7071 8.70711L14.2929 7.29289Z"
      :fill="color"
    />
    <path
      class="icon__stroke"
      d="M8 1H1V15H8"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconOut",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
